// extracted by mini-css-extract-plugin
export default {"form":"EditDocumentModal_form__AJ9T2"};